<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col cols="12" class="limited-scrollable">
        <NewOrdersList
          v-if="$store.state.status[1]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[1]]"
          :filterBy="'pickup'" />
        <PreparingOrdersList
          v-if="$store.state.status[2]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[2]]"
          :filterBy="'pickup'" />
        <ReadyOrdersList
          v-if="$store.state.status[3]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[3]]"
          :filterBy="'pickup'" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import NewOrdersList from '../components/NewOrdersList';
  import PreparingOrdersList from '../components/PreparingOrdersList';
  import ReadyOrdersList from '../components/ReadyOrdersList';

  export default {
    name: 'Pickup',
    components: {
      NewOrdersList,
      PreparingOrdersList,
      ReadyOrdersList
    },
    data: () => ({
      dataLoaded: true
    }),
    methods: {},
  }
</script>

<style scoped></style>